import type { guestAssetsAndNetworksQuery } from '@onramp/data/__generated__/guestAssetsAndNetworksQuery.graphql';
import { assetsAndNetworksQuery } from '@onramp/v2/client/utils/destinationWallets/guestAssetsAndNetworksQuery';
import { useCardDetailsFormState } from '@onramp/v2/client/views/onramp/card-details/hooks/formState';
import { useLazyLoadQuery } from '@cbhq/data-layer';

export const useAssetsAndNetworks = () => {
  const {
    formState: { countryCode, state },
  } = useCardDetailsFormState();

  return useLazyLoadQuery<guestAssetsAndNetworksQuery>(assetsAndNetworksQuery, {
    // US + CA is used as the fallback because it's the most permissive &
    // we can show a nice error later if the user's choice is geo-restricted
    country: countryCode ?? 'US',
    subdivision: state ?? 'CA',
  }).viewer.cbPayTradableAssetsByLocation;
};
